export enum ReportPreviewSearchParams {
  AppraisalComps = 'appraisalComps',
  AppraisalSubjectValue = 'appraisalSubjectValue',
  EffectiveDate = 'effectiveDate',
  ReportConfigSlug = 'reportConfigSlug',
  ClientId = 'clientID',
}
